<template>
  <transition name="fade">
    <CardCarousel v-if="pendingPopular || !pendingPopular && popularProductsFiltered && popularProductsFiltered.length"
                  :title="$t('Суперпропозиція')">
      <Card v-for="item in popularProductsFiltered"
            class="card-carousel__slide"
            :key="item.id"
            :card="item"
      />
    </CardCarousel>
  </transition>
</template>

<script>
  import {mapState} from 'vuex'
  import {http} from '@/axios'
  import CardCarousel from '../components/CardCarousel'
  import Card from '../components/Card'

  export default {
    name: 'SuperOffer',
    components: {
      Card,
      CardCarousel,
    },
    data() {
      return {
        popularProducts: [],
        pendingPopular: false,
        showPopular: true
      }
    },
    computed: {
      ...mapState('restaurants', ['active_restaurant']),
      activeRestaurantId() {
        let id = window.localStorage.getItem('active_restaurant_id') || null
        if (this.active_restaurant) {
          id = this.active_restaurant.id
        }
        return id
      },
      popularProductsFiltered() {
        return this.popularProducts.filter(item => item.restaurant_id == this.activeRestaurantId)
      }
    },
    methods: {
      loadPopularProducts() {
        this.pendingPopular = true
        http.get('/api/product/all-products-with-super-offer')
          .then(({data}) => {
            this.popularProducts = data.data
          })
          .finally(() => {
            this.pendingPopular = false
          })
      },
    },
    created() {
      this.loadPopularProducts()
    }
  }
</script>

<style>

</style>
